import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
// import { uuid } from "@ant-design/plots/es/utils";
import { Form } from "antd";
import { doGetWorkspacePage } from "stores/slices/workspace";

import SelectMultiple from "components/inputs/selectSearchSingle";

// import VoiceSetting from "components/settings/VoiceSetting";
import AppButton from "../../../components/button";
import AppSelect from "../../../components/inputs/select";
import {
  ADDRESS_STATUS,
  CHANNEL_NAME,
  // CHANNEL_PROVIDER,
  CHANNEL_STATUS,
} from "../../../constants/appConstant";
import { doGetAllChannel } from "../../../stores/slices/channel";
import {
  doUpdateAddressStatus,
  setServiceId,
} from "../../../stores/slices/numbers";

const NumberAssignForm = props => {
  const { numberSelected, onCancel, loadingList, onSuccess, setLoadingList } =
    props;
  const formRef = React.useRef(null);
  const voiceSettingRef = React.useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [workspaceSelectedId, setWorkspaceSelectedId] = useState(null);
  const [channelLoading, setChannelLoading] = useState(true);
  const [channelList, setChannelList] = useState(null);
  // const [channelSelected, setChannelSelected] = useState(null);
  const [listAllWorkspace, setListAllWorkspace] = useState([]);
  const [totalWorkspacePages, setTotalWorkspacePages] = useState(0);
  const [workspacecQueries, setWorkspaceQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    statuses: ["ACTIVE"],
    sortFieldWorkspace: "createdTime",
  });
  const [workspaceOption, setOptionWorkspace] = useState([]);
  // const [isShowVoiceSetting, setIsShowVoiceSetting] = useState(false);

  // const providerOptions = [
  //   {
  //     label: t("channelProvider.sms"),
  //     value: CHANNEL_PROVIDER.SMS,
  //   },
  //   {
  //     label: t("channelProvider.mms"),
  //     value: CHANNEL_PROVIDER.MMS,
  //   },
  //   {
  //     label: t("channelProvider.whatsapp"),
  //     value: CHANNEL_PROVIDER.WhatsApp,
  //   },
  //   {
  //     label: t("channelProvider.voice"),
  //     value: CHANNEL_PROVIDER.Voice,
  //   },
  // ];

  // const handleShowVoiceSetting = services => {
  //   if (services?.length === 0) {
  //     setIsShowVoiceSetting(false);
  //   }

  //   const isShowVoiceSetting = services?.includes("voice");
  //   setIsShowVoiceSetting(isShowVoiceSetting);
  // };

  useEffect(() => {
    fetchListWorkspace({
      pageNumber: 1,
      pageSize: 10,
      statuses: ["ACTIVE"],
      sortFieldWorkspace: "createdTime",
    });
  }, []);

  const fetchListWorkspace = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      statuses: ["ACTIVE"],
      sortFieldWorkspace: "createdTime",
    };
    if (
      totalWorkspacePages > 0 &&
      totalWorkspacePages < newRequest.pageNumber
    ) {
      return;
    }
    if (request.isReset) {
      setOptionWorkspace([]);
      setListAllWorkspace([]);
      delete newRequest.isReset;
    }
    setLoadingList(true);
    const { payload } = await dispatch(doGetWorkspacePage(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllWorkspace(removeDuplicates([...payload.content]));
      } else {
        setListAllWorkspace(
          removeDuplicates([...listAllWorkspace, ...payload.content])
        );
      }
      setTotalWorkspacePages(payload.totalPages);
      setWorkspaceQueries(newRequest);
    }
    setLoadingList(false);
  };
  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };

  useEffect(() => {
    if (listAllWorkspace && listAllWorkspace?.length > 0) {
      const newOptions = listAllWorkspace.map(item => {
        return {
          key: item.id,
          label: item.name,
        };
      });
      setOptionWorkspace(newOptions);
    } else {
      setOptionWorkspace([]);
    }
  }, [listAllWorkspace]);

  const handleScrollWorkspace = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      workspacecQueries.pageNumber <= totalWorkspacePages &&
      !loadingList
    ) {
      fetchListWorkspace({
        ...workspacecQueries,
        pageNumber: workspacecQueries.pageNumber + 1,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const handleSearchKeyWorkspace = key => {
    if (key) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        searchKeyName: key,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    } else {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const validateMessages = {
    required: t("validate.required"),
  };

  useEffect(() => {
    if (workspaceSelectedId) {
      setChannelLoading(true);
      getListChannelByWorkspace().then(res => {
        const list = res
          .filter(item => item.status === CHANNEL_STATUS.ENABLED)
          .sort((a, b) => {
            return a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : 0;
          })
          .map(item => {
            return {
              ...item,
              value: item.id,
              label:
                item.name === CHANNEL_NAME.BULKSMS
                  ? t("channelName.BULKSMS")
                  : item.name,
            };
          });
        setChannelList(list);
        setChannelLoading(false);
      });
    }
  }, [workspaceSelectedId]);

  const getListChannelByWorkspace = async () => {
    const { payload } = await dispatch(
      doGetAllChannel({ workspaceId: workspaceSelectedId })
    );
    return payload?.data;
  };

  const onFinish = async fieldsValue => {
    const params = {
      workspaceId: fieldsValue["workspace"],
      serviceStatus: ADDRESS_STATUS.ASSIGNED,
      channelId: fieldsValue["channel"],
      // sms:
      //   channelSelected?.provider[CHANNEL_PROVIDER.SMS] &&
      //   fieldsValue["channelEnable"].includes(CHANNEL_PROVIDER.SMS),
      // mms:
      //   channelSelected?.provider[CHANNEL_PROVIDER.MMS] &&
      //   fieldsValue["channelEnable"].includes(CHANNEL_PROVIDER.MMS),
      // whatsapp:
      //   channelSelected?.provider[CHANNEL_PROVIDER.WhatsApp] &&
      //   fieldsValue["channelEnable"].includes(CHANNEL_PROVIDER.WhatsApp),
      // voice: fieldsValue["channelEnable"]?.includes(CHANNEL_PROVIDER.Voice)
      //   ? true
      //   : false,
    };

    setLoading(true);

    const { payload } = await dispatch(
      doUpdateAddressStatus({ id: numberSelected?.id, params })
    );
    if (payload && payload.status === 200) {
      const serviceId = payload?.data?.id;
      if (serviceId) dispatch(setServiceId(serviceId));
      voiceSettingRef?.current?.submit();
      setLoading(false);
      setIsRefresh(!isRefresh);
      onSuccess();
    } else {
      setLoading(false);
    }
  };

  // const initialValue = () => {
  //   let channelEnable = [
  //     CHANNEL_PROVIDER.SMS,
  //     CHANNEL_PROVIDER.MMS,
  //     CHANNEL_PROVIDER.WhatsApp,
  //     CHANNEL_PROVIDER.Voice,
  //   ];
  //   return {
  //     channelEnable: channelEnable,
  //   };
  // };

  // useEffect(() => {
  //   // Show voice setting when user selected channel first time and voice provider checked
  //   if (channelSelected?.provider?.voice) {
  //     setIsShowVoiceSetting(true);
  //   }
  // }, [channelSelected?.provider]);

  return (
    <div style={{ height: "100%" }}>
      <Form
        ref={formRef}
        layout={"vertical"}
        // initialValues={initialValue()}
        name={"nest-messages"}
        validateMessages={validateMessages}
        onFinish={onFinish}
      >
        <p
          style={numberFormStyle.labelTitle}
          dangerouslySetInnerHTML={{
            __html: t("numbers.assignedNumberFor", {
              number: numberSelected?.address,
            }),
          }}
        ></p>
        <Form.Item name="workspace">
          <SelectMultiple
            type={"select-search"}
            loading={loadingList}
            showSearch
            allowClear={false}
            optionFilterProp="children"
            options={workspaceOption}
            onChange={value => {
              setWorkspaceSelectedId(value);
              // setChannelSelected(null);
              formRef.current.setFieldsValue({
                workspaceId: value,
                channel: null,
              });
            }}
            config={{
              width: "100%",
            }}
            handleSearch={handleSearchKeyWorkspace}
            handleScroll={handleScrollWorkspace}
          />
        </Form.Item>

        {workspaceSelectedId && (
          <>
            <p style={numberFormStyle.labelTitle}>{t("numbers.channel")}</p>
            <Form.Item name="channel">
              <AppSelect
                loading={channelLoading}
                disabled={channelLoading}
                showSearch
                optionFilterProp="children"
                isFilterOption={true}
                isFilterSort={true}
                options={channelList}
                onChange={value => {
                  const item =
                    channelList?.find(item => item.id === value) || null;
                  // setChannelSelected(item);
                  formRef.current.setFieldsValue({
                    channel: value,
                  });
                  // if (!numberSelected && item) {
                  //   let channelEnable = [];
                  //   Object.entries(item.provider).forEach(([key]) => {
                  //     if (value) {
                  //       switch (key) {
                  //         case CHANNEL_PROVIDER.SMS:
                  //           channelEnable.push(CHANNEL_PROVIDER.SMS);
                  //           break;
                  //         case CHANNEL_PROVIDER.MMS:
                  //           channelEnable.push(CHANNEL_PROVIDER.MMS);
                  //           break;
                  //         case CHANNEL_PROVIDER.WhatsApp.toLowerCase():
                  //           channelEnable.push(CHANNEL_PROVIDER.WhatsApp);
                  //           break;
                  //         case CHANNEL_PROVIDER.Voice.toLowerCase():
                  //           channelEnable.push(CHANNEL_PROVIDER.Voice);
                  //           break;
                  //       }
                  //     }
                  //   });
                  //   formRef.current.setFieldsValue({
                  //     channelEnable: channelEnable,
                  //   });
                  // }
                  if (item && item.provider) {
                    let channelEnable = [];

                    Object.entries(item.provider).map(([key, value]) => {
                      if (value) {
                        channelEnable.push(key);
                        return channelEnable;
                      }
                    });
                    formRef.current.setFieldsValue({
                      channelEnable: channelEnable,
                    });
                  }
                }}
              />
            </Form.Item>

            {/* {channelSelected && channelSelected.provider && (
              <>
                <p style={numberFormStyle.labelTitle}>
                  {t("numbers.servicesEnable")}
                </p>
                <Form.Item name="channelEnable">
                  <Checkbox.Group
                    options={providerOptions}
                    onChange={handleShowVoiceSetting}
                  ></Checkbox.Group>
                </Form.Item>
              </>
            )} */}
            {/* {isShowVoiceSetting && (
              <VoiceSetting
                ref={voiceSettingRef}
                serviceIdSelected={numberSelected?.id}
              />
            )} */}
          </>
        )}

        <div
          style={{
            marginTop: "16px",
            display: "flex",
            justifyContent: "end",
            gap: "16px",
          }}
        >
          <AppButton
            label={t("button.cancel")}
            color={"grey"}
            htmlType="button"
            loading={loading}
            onClick={() => {
              onCancel();
            }}
          />
          <AppButton
            label={t("button.confirm")}
            color={"blue"}
            type="primary"
            htmlType="submit"
            loading={loading}
          />
        </div>
      </Form>
    </div>
  );
};
const numberFormStyle = {
  labelTitle: {
    fontWeight: "bold",
    marginBottom: "6px",
  },
};
export default NumberAssignForm;
